export const PortfolioScrollRoutes = {
  About: "about",
  Work: "work"
};
